export default __webpack_public_path__ + "static/media/login-bg.702a8dd8.svg";